export default function Menu(props) {
  const s = props?.size ?? 24;
  const c = props?.color ?? '#292D32';
  const stroke = props?.strokeWidth ?? 1.5;

  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={c}
      strokeWidth={stroke}
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );
}
